/* Libreria di funzioni di uso generale */
import axios from 'axios'
import store from './store'
import { apiUrl } from '@/apiUrl'

const generalLib = {

  /******************************
   *     FUNZIONI GENERICHE
   ******************************/
  /**
   * Impostazioni italiane per il timepicker
   */
  timepicker_it : {
    labels: {
      labelPrevDecade: 'Decade precedente',
      labelPrevYear: "Anno precedente",
      labelPrevMonth: "Mese precedente",
      labelCurrentMonth: 'Mese corrente',
      labelNextMonth: 'Prossimo mese',
      labelNextYear: 'Prossimo anno',
      labelNextDecade: 'Prossima decade',
      labelToday: "Oggi",
      labelSelected: 'Data selezionata',
      labelNoDateSelected: 'Nessuna data selezionata',
      labelCalendar: 'Calendario',
      labelNav: 'Navigazione calendario',
      labelHelp: 'Usa i tasti freccia per navigare nel calendario'
    },
    start_weekday : 1
  },

  /**
   * Chiama il backend per aggiornare il credito utente nello store.
   */
  aggiorna_credito_utente : function () {
    axios.get(  apiUrl.pdoppiaapi.credito_utente )
    .then( ( response ) => {
      store.commit( 'update_credit_data', response.data );
    })
    .catch( (error) => {
      console.error( "[generalLib aggiorna_credito_utente ] Errore aggiornamento credito utente: " + error.response.data );
    });
  },

  /**
   * Aggiorna lo stato delle notifiche, comprendente anche le notifiche
   * da leggere. La statistica delle notifiche viene usata dalla campanella
   * nella navbar per visualizzare le notifiche da leggere.
   */
  aggiorna_stato_notifiche : function () {
    axios.get( apiUrl.mailapi.info_notifiche )
    .then( ( response ) => {
      // Aggiorniamo i dati nello store
      store.commit( 'update_notifications_status', response.data );
    })
    .catch( (error) => {
      // In caso di errore lo notifichiamo in console senza fare altro non
      // essendo un dato critico.
      console.error( "[generalLib attiva_polling_notifiche ]: " + error.response.data );
    });
  },

  /**
   * Manda in polling la funzione aggiorna_stato_notifiche,
   *
   * - quick_start : se true esegue una prima chiamata della funzione
   *                 aggiorna_stato _notifiche prima di andare in polling
   *                 per popolare subito lo store con i dati e non aspettare
   *                 la prima chiamata dopo il polling_interval
   */
  attiva_polling_notifiche : function ( quick_start = false ) {
    const polling_interval = 120000;

    if ( quick_start ) this.aggiorna_stato_notifiche();

    // Inizializza il polling e setta il riferimento al setInterval nello store
    let interval = setInterval( this.aggiorna_stato_notifiche, polling_interval );
    store.commit( 'set_notifications_polling_id', interval );
  },

  /**
   * Arrotonda il valore passatogli alla seconda cifra decimale, utile
   * per gli importi in euro.
   */
  arrotonda_ai_decimali : function ( val ) {
    // To fixed restituisce una stringa, per questo lo riportiamo
    // in float.
    return parseFloat( val.toFixed( 2 ) );
  },

  /**
   * Data la risposta per il download di un file prova a cercarne il nome
   * nell'header 'Content-Disposition', se non lo trova torna un nome di default.
   * Di solito infatti il contenuto dell'header avrà infatti la forma:
   *        attachment;filename=20200908_151317_WYYl.csv
   *
   * - axios_response : oggetto response di axios.
   */
  get_nome_file : function ( axios_response ) {

    const default_name = "downloaded_file";
    let content_disposition = '';

    try {
      content_disposition = axios_response.headers['content-disposition']
    } catch ( error ) {
      console.warn( "[generalLib - nome_file_scaricato]: header content disposition non trovato torno il nome di default");
      return default_name;
    }

    // Il nome del file è quello del primo gruppo individuato, cioè quello
    // indicato nell'espressione regolare dentro le parentesi tonde dopo l'uguale.
    let re = new RegExp( ".*filename=(.*)" );
    let res = re.exec( content_disposition );
    if ( res !== null ) {

      // Ora che ho estratto il nome devo vedere se questo ha i doppi apici
      // prima e dopo ( es: "20220309_120128_fRqs.csv" ) e toglierli. Infatti la classe
      // FileResponse di django li aggiunge ma se settiamo l'header manualmente
      // potremmo scordare di farlo. Gestiamo quindi i due casi.
      let re_b = new RegExp( '^"(.*)"$' );
      let res_b = re_b.exec( res[1] );

      // Se non ho il match non ci sono i doppi apici, andava bene
      // quello che avevo trovato inizialmente, altrimenti ci sono
      // e devo quindi tornare il primo gruppo della seconda regexp.
      let file_name = res_b === null ? res[1] : res_b[1];

      return file_name
    } else {
      console.warn( "[generalLib - nome_file_scaricato]: nome file non rilevato nell'header content-disposition torno il nome di default");
      return default_name;
    }
  },

  /**
   * Data un'array la partiziona in un'array di array dove ogni sotto
   * array avrà al più n elementi.
   */
  sub_array_partition : function ( data, n ) {
    let res = new Array();
    let start = 0;
    let stop = n;

    if ( data === null ) return res;

    while ( start <= data.length ) {
      if ( data.slice( start, stop ).length > 0 ) {
          res.push( data.slice( start, stop ) );
      }
      start += n;
      stop += n;
    }
    return res;
  },

  /**
   * Data un'array partizionata, solitamente con la funzione sub_array_partition,
   * calcola la giusta classe boostrap da dare alle colonne per spaziare
   * adeguatamente il contenuto.
   */
  calculate_bootstrap_col_class : function ( parted_array ) {
    // Torno un default se non ho elementi
    if ( parted_array === null || parted_array.length == 0 ) {
      return "md-12";
    }
    // Prendo a riferimento il primo elemento dell'array che si suppone sia
    // quello pieno completamente, o comunque parzialmente se non ci sono
    // abbastanza elementi per coprire un'intera riga.
    let elem_by_row = Math.floor( 12 / parted_array[0].length );
    return "md-" + elem_by_row;
  },

  /**
   * Date le "coordinate" passategli restituisce il link necessario per aprire
   * il luogo in google map. L'indirizzo può non essere passato, in tal caso la
   * localizzazione sarà meno precisa e circoscritta al solo comune.
   * Anche la provincia potrebbe mancare.
   */
  google_map_link : function ( comune, cap, provincia = null, indirizzo = null ) {

    let base_url = "https://www.google.com/maps/search/@search_string";
    let search_string = '';

    if ( indirizzo != null ) search_string += indirizzo + '+';

    search_string += comune + '+' + cap;

    if ( provincia != null ) search_string += '+' + provincia ;

    return base_url.replace( '@search_string', search_string );
  },

  /*************************************************************
   *     FUNZIONI PER VERIFICARE SE L'APP E' IN MODALITA'
   *     STAND-ALONE, CIOE' SE E' INSTALLATA IN UN DISPOSITIVO
   *     MOBILE
   *************************************************************/

  /**
   * Torna true se la app è installata nel dispositivo mobile, altrimenti torna false.
   * Funzione specifica per chrome.
   * ( https://stackoverflow.com/questions/51735869/check-if-user-has-already-installed-pwa-to-homescreen-on-chrome )
   */
  isChromeStandalone : function () {
    return window.matchMedia('(display-mode: standalone)').matches;
  },

  /**
   * Torna true se la app è in modalità standalone, cioè se risulta
   * lanciata da un link nella home di un sistema apple.
   * La proprietà standalone è infatti presente solo Safari:
   * https://developer.mozilla.org/it/docs/Web/API/Navigator
   */
  isIosStandalone : function () {
    return ('standalone' in window.navigator) && (window.navigator.standalone);
  },

  /**
   * Torna true se lo useragent è un iphone, ipad o ipod
   * false altrimenti.
   */
  isIos : function () {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test( userAgent );
  },

  /************************************
   *    FUNZIONI DI VALIDAZIONE DATI
   ************************************/

  /**
   * Validazione delle cifre in denaro.
   *
   * Verifichiamo il valore con una regex la quale accetta
   * valori solo nel formato: 123.45
   * Cioè con N cifre prima del punto e solo due cifre dopo
   * di esso.
   * Non accetta la virgola come separatore.
   * Torna true se la validazione ha successo, false altrimenti.
   */
  euro_is_valid : function ( val ) {
    let regex = /^\d*(\.\d{0,2})?$/g;
    return regex.test( val ) ;
  },

  /**
   * Validazione della partita iva.
   *
   * Verifica la partita iva, torna true se la partita iva è valida, false altrimenti.
   * Prendiamo l'algoritmo utilizzato da liwe.
   */
  piva_is_valid : function ( pi ) {

    var i, validi, s, c;

    if ( pi == '' ) return false;

    if( pi.length != 11 )
    {
        //console.warn ( "PIVA: %s - Lunghezza non valida numero di cifre diverso da 11: %d", pi, pi.length );
        return false;
    }

    validi = "0123456789";

    for ( i = 0; i < 11; i++ )
    {
        if ( validi.indexOf ( pi.charAt ( i ) ) == -1 )
        {
            //console.warn ( "PIVA: %s - Caratere non valido: %s alla posizione: %d", pi, pi.charAt ( i ), i );
            return false;
        }
    }

    s = 0;
    for ( i = 0; i <= 9; i += 2 ) s += pi.charCodeAt ( i ) - '0'.charCodeAt ( 0 );

    for( i = 1; i <= 9; i += 2 )
    {
        c = 2 * ( pi.charCodeAt ( i ) - '0'.charCodeAt ( 0 ) );
        if ( c > 9 ) c = c - 9;
        s += c;
    }

    if( ( 10 - s % 10  ) % 10 != pi.charCodeAt ( 10 ) - '0'.charCodeAt ( 0 ) )
    {
        //console.warn ( "PIVA: %s - checksum invalido" );
        return false;
    }

    return true;

  },

  /**
   * Valida i numeri di telefono
   */
  phone_is_valid : function ( tel ) {
    return RegExp ( "^[+]?[0-9 ]{6,30}$" ).test ( tel );
  },

  /**
   * Valida il codice fiscale, torna true se ok altrimenti torna false
   */
  cod_fisc_is_valid : function( value ) {

    var caratteri = [ "0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z" ];
    var pari      = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25 ];
    var dispari   = [ 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23 ];
    var cod = value;
    var lettere, numeri;
    var i, test, somma;
    var lettera, carattere, resto, k;

    if ( cod === null ) return false;
    if ( cod.length != 16 ) return false;

    cod = cod.toLowerCase();

    lettere = cod.substr ( 0, 6 ) + cod.substr ( 8, 1 ) + cod.substr ( 11, 1) + cod.substr ( 15 );
    numeri  = cod.substr ( 6, 2 ) + cod.substr ( 9, 2 ) + cod.substr ( 12, 3 );

    for  ( i = 0; i < 10; i++ )
        if ( lettere.charCodeAt ( i ) < 97 || lettere.charCodeAt ( i ) > 122 ) return false;


    for  ( i = 0; i < 8; i++ )
        if ( numeri.charCodeAt ( i ) < 48 || numeri.charCodeAt ( i ) > 57 ) return false;

    //checksum del codice fiscale
    test = cod.substr ( 15,1 );
    somma = 0;
    for ( i = 0; i < 16; i = i + 2 )
    { //dispari
            carattere = cod.substr ( i, 1 );
            for ( k = 0; k < 36; k ++ )
        {
                    if ( carattere == caratteri [ k ] )
            {
                        somma += dispari [ k ];
                        break;
                }
            }
        }

        for ( i = 1; i < 15; i= i + 2 )
    { //pari
            carattere = cod.substr ( i, 1 );
            for ( k = 0; k < 36; k ++ )
        {
                    if ( carattere == caratteri [ k ] )
            {
                        somma += pari [ k ];
                        break;
                }
            }
        }

    resto = somma % 26;
    lettera = String.fromCharCode ( 97 + resto );

    if ( test != lettera )
    {
        lettera = String.fromCharCode ( 98 + resto );
        if ( test != lettera ) return false;
    }

    return true;
  },

  /*****************************************
   *     GENERAZIONE MESSAGE-BOX UTENTE
   *****************************************/

  /**
   * Visualizza a schermo una message box che elenca gli errori ricevuti
   * dalle chiamate di backend.
   *
   * - vue_component : il riferimento al componente che invoca la message box ( this )
   *                   necessario per poterla creare.
   * - error_data    : l'oggetto data che torna dalla chiamata al backend ( error.response.data ) od un messaggio come stringa.
   * - callback      : funzione da eseguire dopo che la messagebox è stata chiusa ( default null )
   */
  backend_error_message_box : function ( vue_component, error_data, callback = null ) {

    // Se passiamo l'oggetto error.response.data:
    // gli errori da django rest arrivano come un oggetto dove le chiavi sono
    // le tipologie di errori, ed i valori, sono array con le descrizioni.
    // Es: {"non_field_errors":["Utente o password non corrette."]}
    // Andiamo a scorrere tutte le chiavi e a costruire una stringa di elementi <li>
    // che andiamo poi a porre come lista nella messagebox che visualizziamo a schermo.
    let error_list_nodes = [];

    // Defininiamo in "h" un alias per la createElement di vue la quale ci permette
    // di generare i nodi html da porre nella message box.
    const h = vue_component.$createElement;

    // Valuatiamo prima il caso in cui error_data non è un oggetto ma sia
    // una stringa semplice od altro.
    if ( typeof( error_data ) !== 'object' ) {
      error_list_nodes.push( h( 'li', {}, error_data ) );
    } else {
      for ( let key in error_data ) {
        // Se l'elemento associato alla chiave è un'array lo passiamo in rassega altrimenti
        // se contiene lui stesso il messaggio lo aggiungiamo
        if ( Array.isArray( error_data[ key ] ) ) {
          for ( let msg of error_data[ key ] ){
            error_list_nodes.push( h( 'li', {}, msg ) );
          }
        } else {
          error_list_nodes.push( h( 'li', {}, error_data[ key ] ) );
        }
      }
    }

    // Costruiamo la struttura finale dell'html della messagebox e la
    // visualizziamo.
    let messageVNode = h ( 'div', {}, [
                              h ( 'p', {}, 'Si è verificato un errore, il sistema riporta:' ),
                              h ( 'ul', {}, error_list_nodes )
                          ] );

    vue_component.$bvModal.msgBoxOk( [messageVNode], {
      title: "Errore.",
      buttonSize: 'sm',
      centered: true
    })
    .then( ( value )=> {
      // Se è stata passata una funzione da eseguire dopo l'ok
      // la eseguiamo.
      if ( callback !== null && typeof callback === 'function' ) callback();
    });

  },

  /**
   * Visualizza a schermo una modale di riepilogo dell'acquisto che permette all'utente
   * di annullare o meno la richiesta fatta.
   * Torna un Promise ( visto che la modale di Vue torna una promise a sua volta al momento
   * in cui si premono i pulsanti ) la quale se valida, è true se l'utente ha premuto ok,
   * ed è false se ha premuto annulla.
   * Anche l'eventuale errore della primise viene tornato.
   *
   * - vue_component: il riferimento al componente che invoca la message box ( this )
   *                   necessario per poterla creare.
   * - importo: importo dell'acquisto che si sta andando ad effettuare.
   * - comp_credito: la componente di credito da cui attingere ( totale, art51, art100, art51c3
   *                 dove art51 e art100 sono uguali a totale )
   */
  acquisto_confirm_message_box : function (  vue_component, importo, comp_credito ) {

    return new Promise (  ( resolve, reject ) => {

      // Defininiamo in "h" un alias per la createElement di vue la quale ci permette
      // di generare i nodi html da porre nella message box.
      const h = vue_component.$createElement;

      importo = parseFloat( importo );
      let credito_attuale = store.state.user.user_credito[ comp_credito ];
      let nuovo_credito = credito_attuale - importo;

      // Arrotondiamo alla seconda cifra decimale
      nuovo_credito = Math.round ( nuovo_credito * 100 ) / 100;

      // Settiamo le stringhe per specificare se il credito è quello totale o quello dei buoni
      let cred_attuale_string = comp_credito === 'art51c3' ? "Credito attuale ART 51 C.3:" : "Credito attuale:";
      let new_cred_string = comp_credito === 'art51c3' ? "Nuovo credito residuo ART 51 C.3:" : "Nuovo credito residuo:";

      // Costruiamo la struttura finale dell'html della messagebox e la
      // visualizziamo.
      const messageVNode = h ( 'table', { class: ['table'] }, [
                              h ( 'tbody', {}, [
                                h ( 'tr', {}, [
                                  h ( 'td', {}, cred_attuale_string ),
                                  h ( 'td', { class : ['font-italic']}, credito_attuale + ' €' ),
                                ]),
                                h ( 'tr', {}, [
                                  h ( 'td', {}, 'Importo operazione:' ),
                                  h ( 'td', { class : ['font-italic'] }, importo + ' €' )
                                ]),
                                h ( 'tr', {}, [
                                  h ( 'td', { class : ['font-weight-bold'] }, new_cred_string ),
                                  h ( 'td', { class : ['font-italic', 'font-weight-bold'] }, nuovo_credito + ' €' )
                                ])
                              ]),
                              h ( 'p', { class : [ 'mt-2' ] }, "Sei sicuro di proseguire?" )
                           ] );

      vue_component.$bvModal.msgBoxConfirm( [messageVNode], {
        title: 'Riepilogo operazione',
        size: 'lg',
        //buttonSize: 'lg',
        okTitle: 'Prosegui',
        cancelTitle: 'Annulla',
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        centered: true
      })
      .then(value => {
        resolve( value );
      })
      .catch(err => {
        reject( err );
      })
    });
  },

  /**
   * Visualizza una message box che informa l'utente che l'acquisto si è conpletato correttamente.
   * Torna una promise in quanto la message box di bootstrap vue torna un promise quando si preme sul
   * pulsante di ok per poter effettuare delle azioni dopo che per l'appunto, il pulsante è stato premuto.
   * Gestisce anche il ritorno dell'errore che opzionalmente può essere catchato dal chiamante, di default
   * viene riportato su console.
   *
   * - vue_component : il riferimento al componente che invoca la message box ( this )
                  necessario per poterla creare.
   * - id_acquisto : id dell'acquisto, da passare se si vuole visualizzare l'id dell'acquisto nel messaggio.
   */
  acquisto_complete_message_box : function (  vue_component, id_acquisto = null ) {

    return new Promise ( ( resolve, reject ) => {

      let mess = ''

      if ( id_acquisto !== null ) {
        mess += "La richiesta è stata inviata con successo con l'id " + id_acquisto + "."
      } else {
        mess += "La richiesta è stata inviata con successo."
      }

      mess += "Riceverai a breve una ulteriore mail di notifica."

      vue_component.$bvModal.msgBoxOk( mess , {
        title: 'Richiesta inviata',
        buttonSize: 'sm',
        okVariant: 'success',
        centered: true
      })
      .then(value => {
        resolve( value );
      })
      .catch( err => {
        console.error( "[acquisto_complete_message_box]: " + err );
        reject( err );
      });

    });
  }
}

export { generalLib };
